import {APIProvider, ControlPosition, Map as GoogleMaps} from "@vis.gl/react-google-maps";
import React from "react";
import GarrisonRouteMapContent from "./garrison-route-map-content.jsx";

const GarrisonRouteMap = ({corporation, routeData, garrisonsList, elapsedSeconds, filter, isCropMode, cropRange}) => {
  if(!corporation) return null;

  const latitude = parseFloat(corporation?.latitude) || 0;
  const longitude = parseFloat(corporation?.longitude) || 0;

  const position = {
    lat: latitude,
    lng: longitude
  }

  return(
    <div className="relative w-full h-full p-2">
      <APIProvider apiKey={corporation?.maps_api_key ?? ""} language={"pt-BR"} libraries={["places"]}>
        <GoogleMaps
          mapId="a7e2dbd01b9a18afb82d00c6"
          defaultZoom={14}
          fullscreenControlOptions={{position: ControlPosition.BOTTOM_RIGHT}}
          reuseMaps={true}
          defaultCenter={position}
          streetViewControl={false}
          mapTypeControl={true}
          scrollwheel={true}
          gestureHandling={'greedy'}
          style={{ height: "100%", width: "100%" }}
          mapTypeControlOptions={{position: ControlPosition.TOP_RIGHT}}
          disableDefaultUI={true}
        />
        <GarrisonRouteMapContent
          garrisonsList={garrisonsList}
          timelineData={routeData}
          elapsedSeconds={elapsedSeconds}
          filter={filter}
          isCropMode={isCropMode}
          cropRange={cropRange}
        />
      </APIProvider>
    </div>
  )
}

export default GarrisonRouteMap;
